import { cva as i } from "class-variance-authority";
var r = {
  sm: "lib:size-4 lib:[&_svg]:size-2.5",
  md: "lib:size-6 lib:[&_svg]:size-4"
}, a = i("lib:peer lib:shrink-0 lib:rounded-[4px] lib:border lib:border-dark-60 lib:shadow-xs lib:outline-none lib:transition-shadow lib:focus-visible:border-ring lib:focus-visible:ring-[3px] lib:focus-visible:ring-ring/50 lib:disabled:cursor-not-allowed lib:disabled:opacity-50 lib:aria-invalid:border-destructive lib:aria-invalid:ring-destructive/20 lib:data-[state=checked]:border-primary lib:data-[state=checked]:bg-primary lib:[&_svg]:text-white", {
  variants: { size: { ...r } },
  defaultVariants: { size: "md" }
});
export {
  a as checkboxVariants,
  r as sizesVariants
};
